module.exports = __webpack_public_path__ + "img/suspensionPoint4.764809cb.png";